var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdBlocked)?_c('div'):(_vm.isProdEnv)?_c('div',{staticClass:"banner-container"},[_vm._m(0)]):_c('div',{staticClass:"banner-container"},[_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-wrapper"},[_c('div',{attrs:{"id":"adfox_163653435270138629"}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-wrapper"},[_c('div',{attrs:{"id":"adfox_16359446499109647"}})])
}]

export { render, staticRenderFns }